import React, { useState } from "react";
import styled from "styled-components";

/* IMPORT IMAGES */
import Img1 from '../Assets/Salarda.jpg';
import Img2 from '../Assets/Gonzaga.png';
import Img3 from '../Assets/Uyamot.jpg';
import Img4 from '../Assets/Banga.jpg';
import Img5 from '../Assets/Jimuel.png';
import Img6 from '../Assets/saga.jpg';
import Img7 from '../Assets/virador.jpg';
import Img8 from '../Assets/Salas.jpg';
import Img9 from '../Assets/Hamoay.jpg';
import Img10 from '../Assets/Cardaña.jpg';
import Img11 from '../Assets/Barro.png';
import Img12 from '../Assets/Lumantas.png';
import Img13 from '../Assets/Tado.png';
import Img14 from '../Assets/Doria.png';
import Img15 from '../Assets/Tadle.png';
import Img16 from '../Assets/Tura.jpg';
import Img17 from '../Assets/Dayot.jpg';
import Img18 from '../Assets/Buñao.jpg';
import Img19 from '../Assets/Jaspe.jpg';

const Team = () => {
  const [openPhases, setOpenPhases] = useState({
    phase1: true,
    phase2: false,
    phase3: false,
    phase4: false,
  });

  const [selectedCard, setSelectedCard] = useState(null);

  const togglePhase = (phase) => {
    setOpenPhases(prev => ({
      ...prev,
      [phase]: !prev[phase]
    }));
    setSelectedCard(null);
  };

  /* DATA */
  const phase1Members = [
    { name: "Paul Jr. E. Salarda", title: "Project Leader", phase: "Phase 1 and 2", img: Img1 },
    { name: "Kathleen Gonzaga", title: "Main Programmer", phase: "Phase 1 and 2", img: Img2 },
    { name: "Richel Uyamot", title: "Lead Programmer", phase: "Phase 1 and 2", img: Img3 },
    { name: "Allen Banga", title: "Lead Programmer", phase: "Phase 1 and 2", img: Img4 },
    { name: "Guenne Zchatzili Tado", title: "Documentor", phase: "Phase 1 and 2", img: Img13 },
    { name: "Jimuel Cabacoy", title: "Backend", phase: "Phase 1 and 2", img: Img5 },
    { name: "Jed Doria", title: "Documentor", phase: "Phase 1 and 2", img: Img14 },
    { name: "Joan Tadle", title: "Documentor", phase: "Phase 1 and 2", img: Img15 },
    { name: "Queenie Hamoay", title: "Backend", phase: "Phase 1 and 2", img: Img9 },
    { name: "Charles Stephen Saga", title: "Backend", phase: "Phase 1 and 2", img: Img6 },
  ];

  const phase2Members = [
    ...phase1Members,
    { name: "Danica Cardaña", title: "Backend", phase: "Phase 2", img: Img10 },
    { name: "Karen Barro", title: "Backend", phase: "Phase 2", img: Img11 },
    { name: "Zach Andrew Lumantas", title: "Backend", phase: "Phase 2", img: Img12 },
  ];

  const phase3Members = [
    { name: "Charles Stephen Saga", title: "Backend", phase: "Phase 3 and 4", img: Img6 },
    { name: "Lizell Virador", title: "Frontend", phase: "Phase 3 and 4", img: Img7 },
    { name: "Reina Faith Salas", title: "Frontend", phase: "Phase 3 and 4", img: Img8 },
    { name: "Dan Joshua Hidalgo Tura", title: "Backend", phase: "Phase 3", img: Img16 },
    { name: "Al Florenz Erong Jaspe", title: "Backend", phase: "Phase 3", img: Img19 },
    { name: "Edna C. Dayot", title: "Backend", phase: "Phase 3", img: Img17 },
    { name: "John Meckael Buñao", title: "Backend", phase: "Phase 3", img: Img18 },
  ];

  const phase4Members = [...phase3Members];

  const phases = [
    { key: "phase1", title: "Phase 1", data: phase1Members },
    { key: "phase2", title: "Phase 2", data: phase2Members },
    { key: "phase3", title: "Phase 3", data: phase3Members },
    { key: "phase4", title: "Phase 4", data: phase4Members },
  ];

  return (
    <Container>

      <TeamDescription>
        We are Team Ina-Ani — transforming agricultural education through technology.
      </TeamDescription>

      {phases.map((phase) => (
        <PhaseSection key={phase.key}>

          <PhaseHeader onClick={() => togglePhase(phase.key)}>
            {phase.title} {openPhases[phase.key] ? "▲" : "▼"}
          </PhaseHeader>

          {openPhases[phase.key] && (
            <ScrollWrapper>
              <TeamContainer>

                {phase.data.map((member, index) => {
                  const isActive = selectedCard === `${phase.key}-${index}`;

                  return (
                    <TeamCard
                      key={index}
                      className={isActive ? "active" : ""}
                      onClick={() =>
                        setSelectedCard(
                          isActive ? null : `${phase.key}-${index}`
                        )
                      }
                    >
                      <ProfileImg src={member.img} alt={member.name} />

                      <TeamName>{member.name}</TeamName>
                      <TeamRole>{member.title}</TeamRole>

                      {isActive && (
                        <ExtraInfo>
                          <p>{member.phase}</p>
                          <p>📧 sample@email.com</p>
                        </ExtraInfo>
                      )}
                    </TeamCard>
                  );
                })}

              </TeamContainer>
            </ScrollWrapper>
          )}
        </PhaseSection>
      ))}
    </Container>
  );
};

export default Team;

/* ================= STYLES ================= */

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
`;

const TeamDescription = styled.p`
  text-align: center;
  margin-bottom: 2rem;
  color: #555;
`;

const PhaseSection = styled.div`
  margin-bottom: 1.5rem;
`;

const PhaseHeader = styled.div`
  font-weight: bold;
  padding: 0.8rem;
  background: linear-gradient(135deg, #2e7d32, #66bb6a);
  color: white;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
  transition: 0.3s;

  &:hover {
    opacity: 0.9;
  }
`;

const ScrollWrapper = styled.div`
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const TeamContainer = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1rem 0;
  width: max-content;
`;

const TeamCard = styled.div`
  width: 150px;
  background: white;
  border-radius: 15px;
  padding: 0.7rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 10px rgba(0,0,0,0.1);

  &:hover {
    transform: translateY(-5px);
  }

  &.active {
    transform: scale(1.15);
    background: #f1f8f4;
    z-index: 10;
  }
`;

const ProfileImg = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 10px;
`;

const TeamName = styled.h4`
  font-size: 0.85rem;
  margin: 0.5rem 0 0;
`;

const TeamRole = styled.p`
  font-size: 0.75rem;
  color: gray;
  margin: 0;
`;

const ExtraInfo = styled.div`
  margin-top: 8px;
  font-size: 0.7rem;
  color: #444;
`;